import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

interface UseAddStaticPartParams {
  onSuccessCallback?: () => void
}

export const useAddStaticPart = ({onSuccessCallback}: UseAddStaticPartParams) => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.addStaticPart,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useAddStaticPart')
        .extras({errorDetails})
        .error('Error occurred while adding a new static part')

      spawnErrorToast(t('error.addStaticPart'))
    },
    onSuccess: async () => {
      onSuccessCallback?.()
      await queryClient.invalidateQueries({queryKey: ['staticPartsList']})
      spawnSuccessToast(t('success.addStaticPart'))
    }
  })
}
